module.exports = __webpack_public_path__ + "static/media/themeChange.aba728f7.gif";